// extracted by mini-css-extract-plugin
export default {"OrderModal":"ModalForOrders_OrderModal__VPds6","h2":"ModalForOrders_h2__6vXsW","OrderModalContent":"ModalForOrders_OrderModalContent__rdgkE"};